// Application configuration and service definitions

// Services offered
export const services = [
  {
    name: 'Tree Planting',
    description: 'Professional tree planting service',
    icon: '🌱'
  },
  {
    name: 'Tree Trimming',
    description: 'Expert pruning and trimming',
    icon: '✂️'
  },
  {
    name: 'Tree Removal',
    description: 'Safe tree removal service',
    icon: '🪓'
  },
  {
    name: 'Stump Grinding',
    description: 'Professional stump removal',
    icon: '🌳'
  },
  {
    name: 'Land Clearing',
    description: 'Complete land clearing service',
    icon: '🚜'
  },
  {
    name: 'Emergency Services',
    description: 'Emergency tree service',
    icon: '⚡'
  }
];

// Configuration for weather and AI features (to be implemented)
export const weatherConfig = {
  // TODO: Add weather API configuration
};

export const aiConfig = {
  // TODO: Add AI analysis configuration
};
